<template>
  <button
      :aria-label="like ? 'Unlike this item' : 'Like this item'"
      class="group w-9 h-9 flex justify-center items-center"
      @click="toggleLike($event)"
  >
  <span v-if="like === 1">
      <img alt="" class="w-5" src="../../assets/icons/global/favorite_on.svg">
    </span>
    <span v-else>
            <img alt="" class="w-5" src="../../assets/icons/global/favorite_off.svg">
    </span>
  </button>
</template>


<script>
export default {
  name: "button-like",
  props: {
    like: 0,
  },
  methods: {
    toggleLike(event) {
      event.stopPropagation();
      // Emit an event to notify the parent component about the like state change
      this.$emit("toggle-like");
    },
  },
}
</script>

<style>

</style>